<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="6000"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
</v-snackbar>
<v-row>
  <v-col cols="12">
  <v-card min-height="530">
    <v-card-title>
      <v-row>
        <v-col cols="4" md="2">
          <v-btn color="#7BC243" @click="openCreateDialog" class="white--text cataloguebtn" v-if="$can('CAN_CREATE_CHARGE')"> New Charge </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search by Benefactor"
          single-line hide-details color="primary"></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
  <v-card-text>
  <v-data-table
      :headers="headers"
      :items="deductions"
      class="elevation-1"
      :search="search"
      disable-pagination
      :hide-default-footer="true"
    >
    <template v-slot:[`header.charge.chargeName`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.benefactor.organisationName`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.beneficiary.organisationName`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.deductionType`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.deductionValue`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.unitofMeasure`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.status`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`item.created`]="{ item }">
       {{item.created | prettyDate }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
       <p v-if="item.status.id === 3"> Not Approved </p>
       <p v-else> Approved </p>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
     <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on" text icon class="actions">
            <v-icon class="secondary--text"> more_horiz </v-icon>
          </v-btn>
        </template>
        <v-list>
          <!-- <v-list-item v-if="$can('CAN_UPDATE_CHARGE')" @click="edit(item)">
            <v-list-item-title> Edit </v-list-item-title>
          </v-list-item> -->
          <v-list-item v-if="$can('CAN_APPROVE_CHARGE')" @click="approveChargeDialog(item)">
            <v-list-item-title> Approve </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="$can('CAN_APPROVE_CHARGE')" @click="declineChargeDialog(item)">
            <v-list-item-title> Reject </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="12" sm="9">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  </v-col>
</v-row>
<v-dialog v-model="createDialog"  max-width="600px" persistent>
   <v-card>
      <v-card-title>
        <span class="headline">Create Charge</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-xl fluid>
          <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout wrap>
          <v-flex xs8>
           <v-autocomplete
              v-on:change="chargeTypeChanged"
              name="chargeType"
              v-model="charge.chargeType"
              :items="chargeTypes"
              item-text="chargeName"
              item-value='chargeName'
              label="Charge Type"
              required>
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs6>
           <v-autocomplete
              name="benefactor"
              v-model="charge.benefactorID"
              :items="benefactors"
              item-text="organisationName"
              item-value='id'
              label="Benefactor"
              v-if="benefactorsField"
              required>
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs6>
           <v-autocomplete
              name="beneficiary"
              v-model="charge.beneficiaryID"
              :items="beneficiaries"
              item-text="organisationName"
              item-value='id'
              label="Beneficiary"
              required>
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs6>
           <v-autocomplete
              name="deductionType"
              v-model="charge.deductionType"
              :items="deductionTypes"
              label="Deduction Type"
              required>
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              name="deductionValue"
              label="Value"
              v-model="charge.deductionValue"
              :rules="deductionValueRules"
              required>
            </v-text-field>
          </v-flex>
          <v-flex xs6>
           <v-autocomplete
              name="unitofMeasure"
              v-model="charge.unitofMeasure"
              :items="unitOfMeasures"
              label="Unit of Measure"
              required>
            >
            </v-autocomplete>
          </v-flex>
          </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="closeCreateDialog"> Cancel </v-btn>
        <v-spacer> </v-spacer>
        <v-btn color="secondary" @click="createCharge"> Create</v-btn>
      </v-card-actions>
   </v-card>
</v-dialog>
<v-dialog v-model="approveDialog"  max-width="600px" persistent>
  <v-card>
    <v-card-title class="body-2 accent--text font-weight-bold">Approve Charge</v-card-title>

    <v-card-text class="accent--text">
      Confirm approval of charge : {{ selectedCharge.charge.chargeName }} for {{ selectedCharge.beneficiary.organisationName }}
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="secondary"
                class="accent--text logoutbtn"
        flat="flat"
        @click="closeApproveChargeDialog"
    
      >
        Cancel
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="#7BC243"
        class="white--text confirmbtn"
        @click="approveCharge"
      >
        Approve
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog v-model="declineDialog"  max-width="600px" persistent>
  <v-card>
    <v-card-title class="body-2 accent--text font-weight-bold">Decline Charge</v-card-title>

    <v-card-text class="accent--text">
      Confirm decline of charge : {{ selectedCharge.charge.chargeName }} for {{ selectedCharge.beneficiary.organisationName }}
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="secondary"
                class="accent--text logoutbtn"
        flat="flat"
        @click="closeDeclineChargeDialog"
         
      >
        Cancel
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="#7BC243"
        class="white--text confirmbtn"
        @click="declineCharge"
      >
        Decline
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import _ from 'lodash'

export default {
  name: 'charge',
  data: function () {
    return {
      chargeTypes: [],
      createDialog: false,
      charge: {},
      benefactors: [],
      beneficiaries: [],
      deductionTypes: [],
      unitOfMeasures: [],
      snackbarColor: '',
      message: '',
      snackbar: false,
      deductionValueRules: [
        v => !!v || 'Deduction value is required'
      ],
      nonMarketers: [],
      marketers: [],
      valid: true,
      fsc: [],
      bankorgs: [],
      statutoryorgs: [],
      benefactorsField: true,
      chargeSelected: {},
      approvedcharges: [],
      unapprovedcharges: [],
      charges: [],
      approveDialog: false,
      declineDialog: false,
      selectedCharge: { charge: {}, beneficiary: {} },
      headers: [
        { text: 'Charge Type', value: 'charge.chargeName' },
        { text: 'Benefactor', value: 'benefactor.organisationName' },
        { text: 'Beneficiary', value: 'beneficiary.organisationName' },
        { text: 'Deduction Type', value: 'deductionType' },
        { text: 'Value', value: 'deductionValue' },
        { text: 'Deduction Measure', value: 'unitofMeasure' },
        { text: 'Date', value: 'created' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      search: '',
      page: 1,
      totalPages: 0,
      pageSize: 5,
      pageSizes: [5, 10],
      deductions: []
    }
  },
  watch: {
    search: function (oldValue, newValue) {
      this.debouncedGetAnswer()
    }
  },
  mounted () {
    // this.chargeTypes = [{'name': 'MILLER_CHARGE'}, {'name': 'WAREHOUSE_CHARGE'}, {'name': 'MARKETER_CHARGE'}]
    this.getChargeTypes()
    this.getMarketers()
    this.getNonMarketers()
    this.getDeductionTypes()
    this.getMeasureTypes()
    this.getFCS()
    this.getBankOrgs()
    this.getStatutoryOrgs()
    this.getCharges()
  },
  methods: {
    openCreateDialog () {
      this.createDialog = true
    },
    chargeTypeChanged () {
      const chargeNameSelected = this.charge.chargeType
      const chargeSelectedArr = this.chargeTypes.filter((charge) => charge.chargeName === chargeNameSelected)
      this.chargeSelected = chargeSelectedArr[0]
      console.log(this.chargeTypes)
      console.log(this.chargeSelected)
      if (this.chargeSelected.chargeType.id === 1) { // government
        this.benefactorsField = false
        this.beneficiaries = this.statutoryorgs
      } else if (this.chargeSelected.chargeType.id === 4) { // marketer
        this.benefactorsField = true
        this.benefactors = this.fcs
        this.beneficiaries = this.marketers
      } else if (this.chargeSelected.chargeType.id === 3) { // bank comissions
        this.benefactorsField = false
        this.beneficiaries = this.bankorgs
      } else { // contractual
        this.benefactors = this.fcs
        this.beneficiaries = this.nonMarketers
        this.benefactorsField = true
      }
    },
    closeCreateDialog () {
      this.createDialog = false
      this.charge = {}
      this.$refs.form.resetValidation()
    },
    createCharge () {
      if (this.$refs.form.validate()) {
        this.createDialog = false
        const url = config.serverURI + '/charges/create'
        this.charge.charge = this.chargeSelected
        axios.post(url, this.charge)
          .then(response => {
            if (response.data.error !== false) {
              this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
              return
            }
            this.getCharges()
            this.charge = {}
            this.$refs.form.resetValidation()
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
          })
          .catch(error => {
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
          })
      }
    },
    getMarketers () {
      const url = config.serverURI + '/organization/get-marketers'
      axios.get(url)
        .then(response => {
          this.marketers = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getNonMarketers () {
      const url = config.serverURI + '/organization/get-non-marketers'
      axios.get(url)
        .then(response => {
          this.nonMarketers = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getFCS () {
      const url = config.serverURI + '/organization/get-fcs'
      axios.get(url)
        .then(response => {
          this.fcs = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getDeductionTypes () {
      const url = config.serverURI + '/charges/deductiontype'
      axios.get(url)
        .then(response => {
          this.deductionTypes = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getMeasureTypes () {
      const url = config.serverURI + '/charges/deductionmeasures'
      axios.get(url)
        .then(response => {
          this.unitOfMeasures = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getBankOrgs () {
      const url = config.serverURI + '/organization/get-bank-org'
      axios.get(url)
        .then(response => {
          this.bankorgs = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getChargeTypes () {
      const url = config.serverURI + '/charges/charges'
      axios.get(url)
        .then(response => {
          this.chargeTypes = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getStatutoryOrgs () {
      const url = config.serverURI + '/organization/get-statutory-org'
      axios.get(url)
        .then(response => {
          this.statutoryorgs = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getRequestParams (name, page, pageSize) {
      const params = {}
      if (page) {
        params.page = page - 1
      }
      if (pageSize) {
        params.size = pageSize
      }
      if (name) {
        params.benefactorName = name
      }
      return params
    },
    handlePageChange (value) {
      this.page = value
      this.getCharges()
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getCharges()
    },
    getCharges () {
      const params = this.getRequestParams(this.search, this.page, this.pageSize)
      const url = config.serverURI + '/charges/deductibles'
      axios.get(url, { params })
        .then(response => {
          const { items, totalPages } = response.data
          this.deductions = items
          this.totalPages = totalPages
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    approveChargeDialog (item) {
      this.approveDialog = true
      this.selectedCharge = item
    },
    declineChargeDialog (item) {
      this.declineDialog = true
      this.selectedCharge = item
    },
    closeApproveChargeDialog () {
      this.approveDialog = false
    },
    closeDeclineChargeDialog () {
      this.declineDialog = false
    },
    approveCharge () {
      const url = config.serverURI + '/charges/approve'
      axios.post(url, this.selectedCharge)
        .then(response => {
          this.closeApproveChargeDialog()
          this.getCharges()
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    declineCharge () {
      const url = config.serverURI + '/charges/decline'
      axios.post(url, this.selectedCharge)
        .then(response => {
          this.closeDeclineChargeDialog()
          this.getCharges()
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    }
  },
  created: function () {
    this.debouncedGetAnswer = _.debounce(this.getCharges, 1000)
  }
}

</script>
<style>
.charge_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.charge_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.charge_box:after, .charge_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.charge_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.charge_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}
.confirmbtn {
  font-weight: 700;
  border-radius: 8px;
}
</style>
